import { initPersonalInfoForm as initStoreLocator } from '@molecules/store-locator/store-locator.mjs';

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-allhubs');

  // Exit on pages where the container does not exist.
  if (!container) return;

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_allHubs = {
    attach: function attach(context) {

      $(once('promutuelAllHubs', '.js-allhubs', context)).each(function () {
        // Add mouseenter event handler for cards.
        [...container.querySelectorAll('.js-allhubs-card')].forEach((card, i) => {
          card.addEventListener('mouseenter', event => {
            showFeaturedImage(i);
          });
        });

        // Add scroll event handler for the horizontal list.
        const hlist = container.querySelector('.horizontal-list-row');
        hlist.addEventListener('scroll', event => {
          const hlistContent = hlist.firstElementChild;
          const cardPositions = [...hlistContent.querySelectorAll('.horizontal-list-card')]
            .map(node => node.offsetLeft - hlistContent.offsetLeft);

          // Start assuming the scroll pos is too far.
          let currentCard = cardPositions.length-1;
          // Loop over cards to see if the scroll pos is left of its middle point.
          for (let i = 1; i < cardPositions.length ; i++) {
            // Get the card's middle point.
            const midPosition = (cardPositions[i] + (cardPositions[i-1])) / 2;
            // Stop the search if the current scroll pos is left enough.
            if (hlist.scrollLeft <= midPosition) {
              currentCard = i-1;
              break;
            }
          }
          showFeaturedImage(currentCard);
        });
      });
    }
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Utilities
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  function showFeaturedImage(index) {
    // Loop over images, and hide all but the one with the same index as the card.
    [...container.querySelectorAll('.js-allhubs-image')].forEach((img, i) => {
      if (i === index) img.classList.remove('allhubs__image--hidden');
      else img.classList.add('allhubs__image--hidden');
    });
  }

})(jQuery, Drupal, drupalSettings, once);
